import React from "react";
import "./MobileUnderConstruction.css";

export default function MobileUnderConstruction() {
  return (
    <div className="mobile-construction-overlay">
      <div className="mobile-construction-window">
        <div className="construction-header">
          <div className="construction-dots">
            <span className="dot close"></span>
            <span className="dot minimize"></span>
            <span className="dot maximize"></span>
          </div>
          <div className="construction-title">Information</div>
        </div>
        <div className="construction-content">
          <h1>Le site sous sa version mobile est en travaux ! 🚧</h1>
          <p>Visitez-le sur ordinateur 👉</p>
          <a href="https://karelberrehouc.com" className="construction-link">
            karelberrehouc.com
          </a>
        </div>
      </div>
    </div>
  );
}
